export const campaignStatusColor = {
  0: '#F5F6FA',
  1: '#221CB6',
  2: '#FFF1E2',
  3: '#FFEEEE',
  4: '#ECFFF3',
  5: '#ff0000',
};

export const campaignStatusTextColor = {
  0: '#A3B2C9',
  1: '#FFFFFF',
  2: '#FC8E0E',
  3: '#ED483D',
  4: '#23E771',
  5: '#ff0000',
};

export const campaignStatusIconColor = {
  0: '#A3B2C9',
  1: '#221CB6',
  2: '#ffffff',
  3: '#FFFFFF',
  4: '#ffffff',
  5: '#ff0000',
};

export const campaignPageTypes = {
  DELETED: 'deleted',
  DASHBOARD: 'dashboard',
  ALL_CAMPAIGNS: 'all-campaigns',
};

export const initialInspectionInstructions = [
  'Look for signals of a trustworthy or high-quality source (e.g., recognized domain, credible references).',
  'If the page is relevant and high-quality, recommend including it in the campaign.',
  'Flag any pages that appear spammy or low-value.',
];

export const initialPersonalizationInstructions = [
  'Use short, choppy sentences and paragraphs.',
  'Limit the use of commas.',
  '5th-grade reading level, use simple words and avoid using jargon.',
];
